import VideoJS from 'video.js';

import * as Controls from '../../ui/UIControlsNames';
import asSVG from '../../ui/icons/as.svg';


const Button = VideoJS.getComponent('Button');

class ASWatchButton extends Button {
    constructor(player, options) {
        super(player, options);
        this.on('click', this.handleClick);
    }
    createEl(tag, props = {}, attrs = {}) {
        const el =  super.createEl(tag, props, attrs);

        el.appendChild(VideoJS.dom.createEl('span', {
            innerHTML: asSVG,
            className: 'vjs-icon vjs-icon--as',
        }, {
            'aria-hidden': 'true'
        }));

        return el;
    }

    buildCSSClass() {
        return `as-watch-button vjs-watch-button ${super.buildCSSClass()}`;
    }

    url(url) {
        if (url === undefined) {
            return this.url_ || '';
        }
        this.url_ = typeof url === 'string' ? url : '';
    }

    handleClick(event) {
        if (!this.url_) {
            return;
        }

        const player = this.player_;
        const currentTime = player.currentTime();
        const duration = player.duration();
        const timecode = (currentTime !== duration) ? Math.round(currentTime) : 0;
        const url = this.url_ + (timecode ? `?t=${timecode}` : '');

        player.pause();

        window.open(url, '_blank');
    }
}

ASWatchButton.prototype.controlText_ = 'Watch on Adult Swim dot com';

VideoJS.registerComponent(Controls.WATCH_BUTTON, ASWatchButton);

export default ASWatchButton;



// WEBPACK FOOTER //
// ./src/player/components/ASReturnControl.js